export default () => import(/* webpackChunkName: 'coffee/activities/harmony/super-rights' */ './SuperRights');
